module.exports = __webpack_public_path__ + "static/media/view off game .f07c8308.svg";